import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from './baseQuery';

const auth = createApi({
    reducerPath: 'auth',
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getUsers: builder.query({
            query: () => 'api/get',
        }),
        getToken: builder.mutation({
            query: (param) => ({
                url: 'api/getToken',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
        getInfor: builder.mutation({
            query: (param) => ({
                url: 'api/getInfor',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
        changePassword: builder.mutation({
            query: (param) => ({
                url: 'api/changePassword',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
    }),
});
export const { useGetUsersQuery, useGetTokenMutation, useSignUpMutation, useGetInforMutation, useChangePasswordMutation } = auth;
export default auth;